import { Box, Button, Modal, Stack, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import { Form, Field } from 'react-final-form'
import { TextField } from 'mui-rff';
import CancelIcon from '@mui/icons-material/Cancel';
import Slide from '@mui/material/Slide';
import { isApiCodeSucess, postRequest } from '../data/helpers/services';
import { HideProgressBar, ShowProgressBar, ShowSuccessAlert } from '../store/alerts';
import { useDispatch } from 'react-redux';
import { AccessTokenContext } from '../routes';
import { ADD_CLONE_JIGSAW } from '../constants';
import { ResetUserInfo } from '../store/Projects';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "70%",
  height: 250,
  borderRadius: "10px",
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderTopRightRadius: "24px"
};


const initialFormData = {
  projectName: "",
  uid: "",
}

export default function AddSuperHeroClone(props: any) {
  const dispatch = useDispatch();

  let { projects, setProjects } = props

  const getCookieAccessToken: any = useContext(AccessTokenContext)
  let accessToken: string = getCookieAccessToken.cookieAccessToken

  const [initialForm, setInitialForm] = useState(initialFormData);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = async (e) => {
    dispatch(ShowProgressBar());
    let requestData = {
      project_name: e.projectName,
      uid: e.uid
    }

    var response: any = null;
    response = await postRequest(ADD_CLONE_JIGSAW, requestData, accessToken);

    if (response) {
      dispatch(HideProgressBar());
      if (isApiCodeSucess(response)) {
        const resData = response.data
        dispatch(ShowSuccessAlert({ visible: true, message: resData.message }));
        dispatch(ResetUserInfo())
        handleClose()

        setProjects([...projects, {
          id: (Number(projects[projects.length - 1].id) + 1).toString(),
          projectName: e.projectName,
          uid: e.uid
        }])

      }
    }
  }

  return (
    <>
      <Button sx={{ fontWeight: "600", cursor: "pointer" }} onClick={handleOpen}>Add Project</Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CancelIcon
            onClick={handleClose}
            sx={{
              color: "#C64242",
              position: "absolute",
              top: "-8px",
              right: "-11px",
              cursor: "pointer"
            }} />

          <Form
            initialValues={{ ...initialForm }}
            onSubmit={handleSubmit}>
            {
              (props: any) => (
                <form onSubmit={props.handleSubmit}>
                  <TextField
                    label="Project Name" name={`projectName`}
                    type="text"
                    required
                    inputProps={{
                      maxLength: 32
                    }}
                  />
                  <TextField
                    label="Unique ID" name={`uid`}
                    sx={{
                      mt: "20px"
                    }}
                    type="text"
                    required={true}
                    inputProps={{
                      maxLength: 24
                    }}
                  />
                  <div className="button-section"
                    style={{
                      marginTop: "30px",
                    }}
                  >
                    <Button sx={{ float: "right" }} type="submit" variant="contained">
                      Submit
                    </Button>
                  </div>
                </form>
              )
            }
          </Form>
        </Box>
      </Modal>
    </>
  )
}
